// extracted by mini-css-extract-plugin
export var measureBox = "_43-0";